import React, { memo, useState, useEffect } from 'react'
import { DatePicker } from 'components/forms/DatePicker'
import moment from 'moment-timezone'
import { Time } from 'components/forms'
import { formatDetentionTime } from 'utils/accessorialHelpers'
import { FORMATS } from 'constants/datetime'

interface IDateTimeInputsProps {
  label: string
  timeStamp: string
  onChange: Function
  timezone: string
  id: string
  editMode: boolean
  isAdmin: boolean
}

export const DateTimeInputs = memo<IDateTimeInputsProps>(
  ({ editMode, id: inputId, isAdmin, label, onChange, timeStamp, timezone }) => {
    const initialState = { date: '', time: '', isValid: false }
    const [state, setState] = useState(initialState)

    // Call onChange when date/time updates
    useEffect(() => {
      onChange(state, inputId)
    }, [inputId, state])

    useEffect(() => {
      if (timeStamp && timezone) {
        const initial = formatDetentionTime(timeStamp, timezone)
        const formatedDateTime = {
          date: initial.date,
          time: isAdmin ? initial.time : '',
        }
        setState(prevState => ({
          ...prevState,
          ...formatedDateTime,
        }))
      }
    }, [timeStamp, timezone])

    const dateChangeHandler = (date: string[]) => {
      if (date[0] !== '') {
        const newDate = moment(date[0]).format(FORMATS.dateFormat)
        setState(prevState => ({
          ...prevState,
          date: newDate,
        }))
      }
    }
    const timeChangeHandler = (value: string, name: string) =>
      setState(prevState => ({
        ...prevState,
        [name]: value,
      }))

    return (
      <div className='row pv2'>
        {!editMode ? (
          <>
            <div className='col-md-6 pl0'>
              <label className='label' htmlFor='description'>
                {label} Date
              </label>
              <DatePicker
                date={state.date}
                onDateChange={dateChangeHandler}
                id={`${inputId}-date`}
                placeholder={label}
              />
            </div>
            <div className='col-md-6'>
              <label className='label' htmlFor='description'>
                {label} Time
              </label>
              <Time
                id={`${label}-time`}
                name='time'
                value={state.time}
                onChange={timeChangeHandler}
                dataTest={`${inputId}-time`}
              />
            </div>
          </>
        ) : (
          <>
            <strong>{label} </strong>
            <span>
              {state.date} {state.time}
            </span>
          </>
        )}
      </div>
    )
  }
)
